import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

// data imports
import { draggableClass } from 'logic/data/Izenda.ReportPartKPIConstants.js';

/**
 * @function KPITextContainer
 * @description render a KPI text tile that is a textarea when editing and a div otherwise
 * @param {Object} props react properties
 */
const KPITextContainer = props => {
    const {
        tile,
        tile: {
            properties
        },
        isPreview
    } = props;

    /**
     * @function updateItemValue
     * @description update value of tile on change
     * @param {object} event change event object from textarea
     */
    const updateItemValue = (event) => {
        tile.updateValue(event.target.value);
    }

    const borderStyles = !props.isBorderConfig ? properties.getBorderStyle() : {};

    return (
        <div className={`kpi-text-container ${draggableClass}`}>
            {
                <textarea
                    className="kpi-text-container__text-area"
                    id={props.id}
                    value={tile.value}
                    onChange={updateItemValue}
                    style={{
                        ...properties.getStyle(),
                        ...borderStyles
                    }}
                    disabled={!isPreview}
                />
            }
        </div>
    );
};

KPITextContainer.propTypes = {
    id: PropTypes.string.isRequired,
    isPreview: PropTypes.bool,
    tile: PropTypes.object.isRequired,
};

export default observer(KPITextContainer);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartKPI/Izenda.KPITextContainer.jsx